import { ThemeColor } from './theme.types'

export const mapCSSVariablesToThemeColor = {
  [ThemeColor.Base]: '--global-base',
  [ThemeColor.Essential]: '--global-essential',
  [ThemeColor.Brand]: '--global-brand',
  [ThemeColor.System]: '--global-system',
  [ThemeColor.Error]: '--global-error',
  [ThemeColor.Warning]: '--global-warning',
  [ThemeColor.Success]: '--global-success',
  [ThemeColor.Info]: '--global-info',
}
